/**
 * 登录注册
 */
import request from "@/utils/request";

// 获取登录验证码
export function imgCaptcha() {
  return request({
    url: "/user/user/hero/imgCaptcha",
    method: "get"
  });
}
// 用户登录
export function login(data) {
  return request({
    url: "/user/edu/cloud/login",
    method: "post",
    data: data
  });
}

// 生成 pc端token(云平台-账号管理)
export function pcToken(token, type) {
  return request({
    url: "/user/edu/cloud/create/pc/token",
    headers: {
      access_token: token,
      device_type: type
    },
    method: "post"
  });
}

// 获取我的账号信息(云平台-账号管理)
export function getAccount() {
  return request({
    url: "/user/edu/cloud/get/my/account",
    method: "post"
  });
}

//获取用户信息(云平台)
export function userById(userId) {
  return request({
    url: "/user/edu/cloud/get/account/by/userId",
    method: "post",
    data: {
      userId: userId
    }
  });
}

// 用户注册
export function register(data) {
  return request({
    url: "/user/user/register/phone",
    method: "post",
    data: data
  });
}

//获取手机短信验证码
export function phoneCaptcha(phoneNum) {
  return request({
    url: `/user/user/register/phoneCaptcha/${phoneNum}`,
    method: "get"
  });
}

//获取手机短信验证码(注册)
export function getForgetPassCode(username) {
  return request({
    url: `/user/user/register/phoneCaptcha/${username}`,
    method: "get"
  });
}

// 校验验证码(注册)
export function forgetPasswordCode(data) {
  return request({
    url: "/user/user/hero/check/registerCode",
    method: "post",
    data: data
  });
}

//获取忘记密码验证码

export function ForgetPassCode(username) {
  return request({
    url: `/user/user/getForgetPassCode/${username}`,
    method: "get"
  });
}

//校验验证码(忘记密码)
export function ForgetPasswordCode(data) {
  return request({
    url: "/user/user/check/forgetPasswordCode",
    method: "post",
    data: data
  });
}

// 用户修改密码
export function forgetPassUpdate(data) {
  return request({
    url: "/user/user/app/forgetPassUpdate",
    method: "post",
    data: data
  });
}

//获取学校信息
export function queryBySchoolCode(data) {
  return request({
    url: "/basic/baseEduSchool/queryBySchoolCode",
    method: "post",
    data: {
      schoolCode: data
    }
  });
}

// 获取学段
export function getSchoolTypeList(data) {
  return request({
    url: "/basic/baseEduStudyPhase/queryAll",
    method: "post",
    data: data
  });
}

//  获取年段
export function getGradeList(studyPhaseId) {
  return request({
    url: "/basic/edu/cloud/grade/get/list",
    method: "post",
    data: {
      studyPhaseId: studyPhaseId
    }
  });
}
// 获取学科
export function getSubjectList(gradeId) {
  return request({
    url: "/basic/edu/cloud/subject/get/list",
    method: "post",
    data: {
      gradeId: gradeId
    }
  });
}
// 用户完善信息
export function perfect(data) {
  return request({
    url: "/user/edu/perfect/user",
    method: "post",
    data: data
  });
}

// 校验验证码(注册)
export function registerCode(data) {
  return request({
    url: "/user/user/hero/check/registerCode",
    method: "post",
    data: data
  });
}

//判断手机号是否注册
export function isUse(data) {
  return request({
    url: "/user/user/hero/phone/isUse",
    method: "post",
    data: {
      username: data
    }
  });
}

//查看该用户的学校是否被禁用(教育)
export function disabled(username) {
  return request({
    url: "/user/edu/hero/check/disabled",
    method: "post",
    data: {
      username: username
    }
  });
}

// 安徽教育云开放平台认证接口
export function authentication(type, data, path) {
  return request({
    url: `/user/hero/ahy/authentication?${type}=${data}&wxUrl=${path}`,
    method: "get"
  });
}

// 判断魔方用户是否绑定(教育云平台)
export function judgeCubeIsBind(cubeCommonUserId) {
  return request({
    url: `/user/edu/cloud/cube/hero/judgeCubeIsBind?cubeCommonUserId=${cubeCommonUserId}`,
    method: "get"
  });
}

// 绑定魔方用户(教育云平台)
export function bindCubeUserInfo(data) {
  return request({
    url: `/user/edu/cloud/cube/hero/bindCubeUserInfo`,
    method: "post",
    data: data
  });
}

// 获取已绑定用户登录信息(教育云平台)
export function getBoundLoginInfo(platformCode, userId) {
  return request({
    url: `/user/edu/cloud/cube/hero/getBoundLoginInfo?platformCode=${platformCode}&userId=${userId}`,
    method: "post"
  });
}
// // 平台加密狗
// export function version() {
//   return request({
//     url: `/user/baseSecurity/hero/select/version?pfId=${window.g.platformCode}`,
//     method: "get",
//   });
// }
// // 登录时判断加密狗是否有效
// export function verificationVersion() {
//   return request({
//     url: `/user/baseSecurity/hero/check/version?pfId=${window.g.platformCode}`,
//     method: "post",
//   });
// }
// // 上下续费版本文件
// export function versionfileupload(data) {
//   return request({
//     url: `/user/baseSecurity/hero/upgrade/version?pfId=${window.g.platformCode}`,
//     method: "post",
//     headers: { 'Content-Type': 'multipart/form-data' },
//     data: data
//   });
// }

// 获取客户端 ip 和 mac 地址(教育云平台)
export function getIpMac() {
  return request({
    url: `/user/edu/cloud/hero/get/addr`,
    method: "get"
  });
}

// 自动登录
export function autoLogin(data) {
  return request({
    url: `/user/edu/cloud/hero/auto/login`,
    method: "post",
    data: data
  });
}

// 获取账号注销短信验证码(V3)
export function logoutCaptcha(data) {
  return request({
    url: `/user/edu/cloud/v3/send/logout/sms/captcha`,
    method: "post",
    data: data
  });
}
// 注销账号(V3)
export function logoutUser(data) {
  return request({
    url: `/user/edu/cloud/v3/logout/user`,
    method: "post",
    data: data
  });
}


// WEBPACK FOOTER //
// ./src/api/login.js